import { type CSSProperties } from 'react';

/**
 * PDF header3Column: flexDirection row, justifyContent space-between, alignItems center
 * headerSingleColumn: width 20%
 * pageHeaderImage: width 140pt -> 194px (scale 1.389)
 * pageName: textTransform uppercase, fontWeight 700, marginTop 10pt -> 14px
 *
 * 3-column flex with `space-between`: thumbnail (fixed left), logo (middle),
 * and text column (fixed right).
 */

export const PAGE_HEADER_OUTER_STYLE: CSSProperties = {
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	alignItems: 'flex-start',
	flexShrink: 0,
	gap: '12px',
	paddingBottom: '18px'
};

export const PAGE_HEADER_THUMBNAIL_COL_STYLE: CSSProperties = {
	width: '194px',
	flexShrink: 0
};

// Max-bounded so a square/portrait thumbnail can't inflate the header; no object-fit (html2canvas 1.4.1 ignores it and stretches).
export const PAGE_HEADER_THUMBNAIL_IMG_STYLE: CSSProperties = {
	maxWidth: '194px',
	maxHeight: '110px',
	display: 'block'
};

export const PAGE_HEADER_LOGO_COL_STYLE: CSSProperties = {
	flexShrink: 0
};

export const PAGE_HEADER_TEXT_COL_STYLE: CSSProperties = {
	textAlign: 'right',
	lineHeight: '1.4',
	textTransform: 'uppercase',
	fontSize: '16px'
};

export const PAGE_HEADER_NAME_STYLE: CSSProperties = { fontWeight: 700 };

export const PAGE_HEADER_TITLE_STYLE: CSSProperties = {
	textTransform: 'uppercase',
	fontWeight: 700,
	paddingTop: '14px',
	whiteSpace: 'nowrap'
};

export const RTA_LOGO_SVG_STYLE: CSSProperties = {
	width: '194px',
	height: 'auto',
	display: 'block'
};
